import { ValueObject } from '@nx-smartmonkey/shared/domain';

export interface ProjectCustomerEmailItemProps {
  from?: string;
  enabled: boolean;
  subject?: string;
  body?: string | null;
  updated_at?: Date;
  pod_fields?: string[];
}

export class ProjectCustomerEmailItem extends ValueObject<ProjectCustomerEmailItemProps> {
  get from(): string | undefined {
    return this.props.from;
  }
  set from(from: string | undefined) {
    this.props.from = from;
  }
  get enabled(): boolean {
    return this.props.enabled;
  }
  get subject(): string | undefined {
    return this.props.subject;
  }
  set subject(subject: string | undefined) {
    this.props.subject = subject;
  }
  get body(): string | null | undefined {
    return this.props.body;
  }
  set body(body: string | null | undefined) {
    this.props.body = body;
  }
  get updated_at(): Date | undefined {
    return this.props.updated_at;
  }
  get pod_fields(): string[] | undefined {
    return this.props.pod_fields;
  }
  private constructor(props: ProjectCustomerEmailItemProps) {
    super(props);
  }
  static create(props: ProjectCustomerEmailItemProps): ProjectCustomerEmailItem {
    return new ProjectCustomerEmailItem(props);
  }
}
